import type { PreviewStartAction } from '../types/actions'
import { APP_STATUS } from '../types/enums'

import { actionFactory } from './factory'

export const previewStart = actionFactory<PreviewStartAction>((state) => {
  if (state.appStatus !== APP_STATUS.FAILED) {
    state.appStatus = APP_STATUS.LOADING
  }
}, 'previewStart')
